const CellPhoneCountrys = [
    { value: "+54", label: "Argentina (+54)", code: "AR" },
    { value: "+1", label: "United States (+1)", code: "US" },
    { value: "+52", label: "Mexico (+52)", code: "MX" },
    { value: "+55", label: "Brazil (+55)", code: "BR" },
    { value: "+34", label: "Spain (+34)", code: "ES" },
    { value: "+44", label: "United Kingdom (+44)", code: "GB" },
    { value: "+49", label: "Germany (+49)", code: "DE" },
    { value: "+33", label: "France (+33)", code: "FR" },
    { value: "+81", label: "Japan (+81)", code: "JP" },
    { value: "+86", label: "China (+86)", code: "CN" },
    { value: "+91", label: "India (+91)", code: "IN" },
    { value: "+7", label: "Russia (+7)", code: "RU" },
    { value: "+39", label: "Italy (+39)", code: "IT" },
    { value: "+61", label: "Australia (+61)", code: "AU" },
    { value: "+82", label: "South Korea (+82)", code: "KR" },
    { value: "+63", label: "Philippines (+63)", code: "PH" },
    { value: "+64", label: "New Zealand (+64)", code: "NZ" },
    { value: "+971", label: "United Arab Emirates (+971)", code: "AE" },
    { value: "+92", label: "Pakistan (+92)", code: "PK" },
    { value: "+20", label: "Egypt (+20)", code: "EG" },
    { value: "+27", label: "South Africa (+27)", code: "ZA" },
    { value: "+56", label: "Chile (+56)", code: "CL" },
    { value: "+57", label: "Colombia (+57)", code: "CO" },
    { value: "+58", label: "Venezuela (+58)", code: "VE" },
    { value: "+51", label: "Peru (+51)", code: "PE" },
    { value: "+503", label: "El Salvador (+503)", code: "SV" },
    { value: "+502", label: "Guatemala (+502)", code: "GT" },
    { value: "+504", label: "Honduras (+504)", code: "HN" },
    { value: "+505", label: "Nicaragua (+505)", code: "NI" },
    { value: "+506", label: "Costa Rica (+506)", code: "CR" },
    { value: "+593", label: "Ecuador (+593)", code: "EC" },
    { value: "+598", label: "Uruguay (+598)", code: "UY" },
    { value: "+592", label: "Guyana (+592)", code: "GY" },
    { value: "+591", label: "Bolivia (+591)", code: "BO" },
    { value: "+595", label: "Paraguay (+595)", code: "PY" },
    { value: "+601", label: "Malaysia (+601)", code: "MY" },
  ];
  export default CellPhoneCountrys;